import { TownPartDto } from "../../interfaces";
import { apiToNumber, apiToString } from "@pasport/react-common";
import { TownPartApiDto } from "./TownPartApi.dto";

export const mapApiToTownPart = (response: TownPartApiDto): TownPartDto => {
	return {
		id: apiToNumber(response.uzemi_id),
		name: apiToString(response.nazev),
	};
};